// extracted by mini-css-extract-plugin
module.exports = {"brand_wrapper":"Brand_brand_wrapper__YNz1B","brand":"Brand_brand__IGoHT","first_brand":"Brand_first_brand__6AOzV","brand_item":"Brand_brand_item__vc8V5"};